/* @sravni/react-header version 0.2.43 */
var LINK_ALIAS;
(function (LINK_ALIAS) {
    LINK_ALIAS["SEARCH"] = "search";
})(LINK_ALIAS || (LINK_ALIAS = {}));

export { LINK_ALIAS };
//# sourceMappingURL=links.js.map
